/**
 * What a Rowted admin may do — `docs/rowted-admin-v2.md` §2.3.
 *
 * In `shared/` for the reason the tenant permission matrix is: §0.6 says
 * "roles are enforced on the server, in one place, and the client only hides
 * what the role cannot do". Two copies of this table would drift, and the way
 * it would drift is a button that is visible and then refused — which teaches
 * people the app is broken rather than that they lack an ability.
 *
 * Five roles and seven abilities rather than the tenant side's area × level
 * matrix. The platform surface is seven screens; a matrix for it would be
 * ceremony, and the thing that actually varies is not "how much of the clients
 * list can you see" but "may you touch the keys".
 */
export const PLATFORM_ROLES = ['owner', 'admin', 'support', 'billing', 'readonly'];
export const PLATFORM_ROLE_LABELS = {
    owner: 'Owner',
    admin: 'Admin',
    support: 'Support',
    billing: 'Billing',
    readonly: 'Read only',
};
/** The sentence on the "What each role can do" card. */
export const PLATFORM_ROLE_BLURBS = {
    owner: 'Everything, including keys, roles and invites.',
    admin: 'Clients, settings and prices. Not keys, not other admins.',
    support: 'Clients and signing in as one, with consent recorded. No settings.',
    billing: 'Prices and plans, and everything anybody can read.',
    readonly: 'Reads every screen and changes nothing.',
};
/**
 * Who has each ability. Read it as the §2.3 table turned on its side — a row
 * per ability rather than per role, because every check asks "who may do
 * this", never "what may this person do".
 */
export const PLATFORM_ABILITY_ROLES = {
    read: PLATFORM_ROLES,
    signInAs: ['owner', 'admin', 'support'],
    clients: ['owner', 'admin'],
    settings: ['owner', 'admin'],
    pricing: ['owner', 'admin', 'billing'],
    integrations: ['owner'],
    admins: ['owner'],
    emailLog: ['owner', 'admin'],
};
export const platformCan = (role, ability) => PLATFORM_ABILITY_ROLES[ability].includes(role);
/** Every ability a role has, for the client's own hiding. */
export const platformAbilitiesOf = (role) => Object.keys(PLATFORM_ABILITY_ROLES)
    .filter((ability) => platformCan(role, ability));
//# sourceMappingURL=platform-roles.js.map